import React, {useEffect, useState} from "react";
import {AES, enc} from 'crypto-js';
import axios from "axios";
import moment from "moment";

import Widget from "components/widget/Widget";
import {useUserAuth} from "../../../context/UserAuthContext";
import {useNavigate} from "react-router-dom";
import useAsyncEffect from "use-async-effect";
import NftCard from "../../../components/card/NftCard";
import NFt2 from "assets/img/nfts/Nft2.png";
import NFt4 from "assets/img/nfts/Nft4.png";
import NFt3 from "assets/img/nfts/Nft3.png";
import NFt5 from "assets/img/nfts/Nft5.png";
import NFt6 from "assets/img/nfts/Nft6.png";
import avatar1 from "assets/img/avatars/avatar1.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
import UsersOverView from "../users/components/UsersOverView";
import {columnsDataUsersOverview} from "../users/variables/columnsDataUsersOverview";
import Card from "../../../components/card";
import ProductCatalogPage from "./components/ProductCatalogPage";
import Alerts from "../error";

const ProductCatalog = () => {

    var sv = "";
    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/LAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let [productCatalog, setProductCatalog] = useState([]);
    const [message, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    useAsyncEffect(async () => {

        function getProductCatalog() {
            if ((accesscontrollevel.toString() !== "0")) {
                var url = CROMPTON_URL + "product/catalog/all"
                axios({
                    method: "GET", url: url, headers: {
                        Authorization: decryptedValue,
                    }

                }).then((res) => {
                    //console.log(res.data)

                    setProductCatalog([...res.data].sort((a, b) => b.def - a.def));

                    //setProductCatalog(res.data)
                    //productCatalog = res.data
                    setIsLoading(false)

                }).catch((error) => {
                    setIsLoading(false)
                    //console.log(error)
                    if (error.response.data.status === "401" || error.response.data.status === "403") {
                        handleLogOut();
                    }
                })

            } else {
                setIsLoading(false)
                //console.log("Inside stats non admin")
                setErrorMessage("You do not have permission to view this. Please contact admin.")
            }
        }

        getProductCatalog()

    }, [sv]);


    return (
        <div>
            {
                !isLoading &&
                <Card extra={'w-full h-full mt-3 p-4'}>
                    {accesscontrollevel.toString() !== "0" ?
                        <ProductCatalogPage
                            tableData={productCatalog}
                            columnsData={[]}
                        /> : <Alerts/>
                    }
                </Card>
            }
        </div>


    );
};

export default ProductCatalog;
